import Glide, { Controls, Autoplay } from '@glidejs/glide/dist/glide.modular.esm'

/**
 * Image Gallery Flexi Block
 */
( () => {
    const blocks = document.querySelectorAll( '.block--gallery' )

    if ( !blocks ) {
        return
    }

    function initGallery( block ) {
        const glideEl = block.querySelector( '.glide' )
        const infiniteLoop = glideEl.dataset.infiniteLoop === 'true'

        const glide = new Glide( block.querySelector( '.glide' ), {
            type: 'carousel',
            animationDuration: 100,
        })

        glide.mount({ Controls })

        if ( !infiniteLoop ) {
            glide.on( 'move.after', () => {
                glideEl.querySelector( '.glide__arrow--left' ).disabled = glide.index === 0
                glideEl.querySelector( '.glide__arrow--right' ).disabled = glide.index === glideEl.querySelectorAll( '.glide__slide:not(.glide__slide--clone)' )?.length - 1
            })
        }
    }
    blocks.forEach( initGallery )
})();


/**
 * Page Banner
 */
 ( () => {
    const banner = document.querySelector( '.glide--banner' )

    if ( !banner ) {
        return
    }


    const gliderBannerSlides = banner.querySelectorAll( '.glide__slide' )

    const glideBannerSlider = new Glide( banner, {
        type: 'carousel',
        gap: 0,
        autoplay: 7000,
        hoverpause: true,
        animationDuration: 100,
    });

    if( gliderBannerSlides.length > 1 ) {
        glideBannerSlider.mount({ Controls, Autoplay })
        banner.classList.add( 'transition-fade' )
    } else {
        glideBannerSlider.destroy()
        banner.querySelector( '.glide__arrows' ).style.display = 'none'
    }
    
})();


/**
 *  Archive CPT Loop
 */
 ( () => {


    const archiveSection = document.querySelector( '.archive__content-image-loop' );


    if( !archiveSection ) {
        return
    }

    const archiveBock = archiveSection.querySelectorAll( '.archive__content-image-block' )

    archiveBock.forEach( block  => {
        
        const glideSlides = block.querySelector( '.glide__slides' )
        const blockContent = block.querySelector( '.content-image__content' )



        const setBlockGalleryHeight = () => {
            glideSlides.style.height = blockContent.offsetHeight + 'px'
        }

        setBlockGalleryHeight()

        window.addEventListener( 'resize', function() {
            setBlockGalleryHeight();
        })

    })


    const postArchiveGallery = document.querySelectorAll( '.glide--archive-posts' )


    postArchiveGallery.forEach( postSlide => {

        const gliderArchivePostSlide = postSlide.querySelectorAll( '.glide__slide' )
    
        const glideArchivePostSlider = new Glide( postSlide, {
            type: 'carousel',
            gap: 0,
            autoplay: 7000,
            hoverpause: true,
            animationDuration: 100,
        });


        if( gliderArchivePostSlide.length > 1 ) {
            glideArchivePostSlider.mount({ Controls, Autoplay })
            postSlide.classList.add( 'transition-fade' )
        } else {
            glideArchivePostSlider.destroy()
            postSlide.querySelector( '.glide__arrows' ).style.display = 'none'
        }

    }) 

})();



/**
 * CPT Gallery Single Slider
 */
 ( () => {
    const singleGallery = document.querySelector( '.glide--single-gallery' )

    if ( !singleGallery ) {
        return
    }


    const childSlider = document.querySelector( '.glide--single-gallery__child' )

    const singleGallerySlides = singleGallery.querySelectorAll( '.glide__slide' )

    const singleGallerySlider = new Glide( singleGallery, {
        type: 'carousel',
        gap: 0,
        autoplay: 7000,
        hoverpause: true,
        animationDuration: 100,
    });
    const childSlide = new Glide( childSlider, {
        type: 'carousel',
        perView: 1,
        gap: 0,
        animationDuration: 100,
    }).mount();

    singleGallerySlider.on("run", function () {
        childSlide.go(`=${singleGallerySlider.index}`);
    });

    if( singleGallerySlides.length > 1 ) {
        singleGallerySlider.mount({ Controls, Autoplay })
        singleGallery.classList.add( 'transition-fade' )
        childSlider.classList.add( 'transition-fade' )
    } else {
        singleGallerySlider.destroy()
        singleGallery.querySelector( '.glide__arrows' ).style.display = 'none'
    }
    
})();


